{
  "exitButton": "Вихід",
  "bagReportButton": "Помітили помилку?",
  "profileLink": "Профіль",
  "bagReportDialog": {
    "title": " Щось пішло не так?",
    "desc": "Щось пішло не за планом, або не так як ви очікували? Опишіть проблему з якою ви стикнулись та ми її виправимо найближчим часом",
    "form": {
      "textArea": {
        "label": "Опишіть що саме пішло не так?",
        "placeholder": "Напишіть пару слів, та додайте скріншоти нижче"
      },
      "fileInput": {
        "label": "Докладіть файл або відео (опціонально):",
        "placeholder": {
          "firstPart": " Перетягніть файл у цю зону,",
          "secondPart": "або",
          "thirdPart": "натисніть тут"
        }
      },
      "button": {
        "cancel": "Скасувати",
        "send": "Відправити"
      }
    }
  }
}
